export default __webpack_public_path__ + "static/media/emprestimo.0a57aaa1.png";